import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AppRoutes } from '@fitup-monorepo/routes/lib/app-routes';
import { firstValueFrom } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { clubActions } from './state/club/club.actions';
import { LocalStorageService } from '@fitup-monorepo/core/lib/services/local-storage.service';
import { AuthServerProvider } from '@fitup-monorepo/core/lib/services/auth/auth-jwt.service';
import { PlatformService } from '@fitup-monorepo/core/lib/services/platform/platform.service';
import { BrowserService } from '@fitup-monorepo/core/lib/services/browser/browser.service';

export const invitationCodeToJoinKey = 'invitationCodeToJoinKey';

export const joinClubWithCodeGuard: CanActivateFn = async (route: ActivatedRouteSnapshot): Promise<UrlTree> => {
  const localStorageService = inject(LocalStorageService);
  const authServerProvider = inject(AuthServerProvider);
  const router = inject(Router);
  const platformService = inject(PlatformService);
  const browserService = inject(BrowserService);
  const store = inject(Store);
  const actions$ = inject(Actions);
  const invitationCode = route.paramMap.get('invitationCode');

  const storedCode = await localStorageService.retrieve(invitationCodeToJoinKey);
  if (!platformService.isNative() && !storedCode) {
    await browserService.openUrlInApp(AppRoutes.JOIN_GROUP_WITH_CODE(invitationCode).slice(1), () => {
      localStorageService.store(invitationCodeToJoinKey, invitationCode);
    });
  } else {
    await localStorageService.store(invitationCodeToJoinKey, invitationCode);
  }

  if (!(await authServerProvider.isAuthenticated())) {
    return router.parseUrl(AppRoutes.ROOT);
  }

  await localStorageService.clear(invitationCodeToJoinKey);

  store.dispatch(clubActions.joinClub({ invitationCode }));

  const result = await firstValueFrom(
    actions$.pipe(ofType(clubActions.joinClubSuccess, clubActions.joinClubFailure), take(1), filter(Boolean))
  );

  if (result.type === clubActions.joinClubSuccess.type) {
    return router.parseUrl(AppRoutes.GROUP_DETAIL((result as ReturnType<typeof clubActions.joinClubSuccess>).group.id));
  }

  return router.parseUrl(AppRoutes.TABS_CHALLENGES);
};
